import { useMemo } from 'react';

import { usePetitionUpdatePageData } from '#src/app/pages/petitionUpdate/details/pageContext';
import type { UseShareActionsOptions } from '#src/app/shared/hooks/share';

import type { Channel } from './types';
import { useGetShareContent } from './useGetShareContent';
import { useGetShareTrackingData } from './useGetShareTrackingData';

export function useShareOptions(_opts: { disableShortLinks: boolean }): UseShareActionsOptions<Channel> {
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();

	const {
		data: {
			update: {
				petition: { bestStoryShareVisual },
			},
		},
	} = usePetitionUpdatePageData();

	return useMemo(
		() => ({
			trackingEventName: 'share_update',
			getContent,
			getTrackingData,
			config: {
				instagramStories: {
					enabled: !!bestStoryShareVisual,
				},
				tiktok: {
					enabled: !!bestStoryShareVisual,
				},
			},
		}),
		[getContent, getTrackingData, bestStoryShareVisual],
	);
}
